<template>
    <div class="table-expand-container">
        <rcTable ref="rcTable"
                 :tableAttr="tableAttr"></rcTable>
    </div>
</template>
<script>
import rcTable from '@/views/components/basic/rcTable'
import API from '@/service/api'

export default {
    props: ['data', 'tabPane'],
    components: {
        rcTable
    },
    data () {
        return {
            record: false,
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.GET_AUDIT_APPROVAL_AMOUNT_DETAIL, true),
                    params: {
                        chargeType: this.data.chargeType,
                        orderId: encodeURIComponent(this.data.id)
                    }
                },
                isMultiSelect: false,
                searchShow: false,
                columnsChooseShow: false,
                referenceVal: 1320,
                columns: [
                    {
                        title: this.$t('原价'),
                        key: 'originalCost',
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 100,
                        render: (h, params) => {
                            const { originalCost } = params.row
                            return h('span', { class: originalCost >= 0 ? 'balance-color' : 'balance-color-green' }, this.$money(originalCost))
                        }
                    },
                    {
                        title: this.$t('折扣优惠金额'),
                        key: 'orgDiscount',
                        columnShow: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 100,
                        render: (h, params) => {
                            const { orgDiscount } = params.row
                            return h('span', { class: 'balance-color' }, this.$money(orgDiscount))
                        }
                    },
                    {
                        title: this.$t('优惠券抵扣金额'),
                        key: 'couponDiscount',
                        columnShow: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 100,
                        render: (h, params) => {
                            const { couponDiscount } = params.row
                            return h('span', { class: 'balance-color' }, this.$money(couponDiscount))
                        }
                    },
                    {
                        title: this.$t('抵扣现金券支付金额'),
                        key: 'deductCouponDiscount',
                        columnShow: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 100,
                        render: (h, params) => {
                            const { deductCouponDiscount } = params.row
                            return h('span', { class: 'balance-color' }, this.$money(deductCouponDiscount))
                        }
                    },
                    {
                        title: this.$t('充值现金券支付金额'),
                        key: 'couponAmount',
                        columnShow: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 100,
                        render: (h, params) => {
                            const { couponAmount } = params.row
                            return h('span', { class: 'balance-color' }, this.$money(couponAmount))
                        }
                    },
                    {
                        title: this.$t('现金支付金额'),
                        columnShow: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        key: 'cashAmount',
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 100,
                        render: (h, params) => {
                            const { cashAmount } = params.row
                            return h('span', { class: cashAmount >= 0 ? 'balance-color' : 'balance-color-green' }, this.$money(cashAmount))
                        }
                    },
                    {
                        title: this.$t('信用额度支付金额'),
                        columnShow: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        key: 'creditAmount',
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 100,
                        render: (h, params) => {
                            const { creditAmount } = params.row
                            return h(
                                'span',
                                { class: Number(params.row.creditAmount) < 0 ? 'balance-color-green' : 'balance-color' },
                                this.$money(creditAmount)
                            )
                        }
                    }
                ]
            }
        }
    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.table-expand-container {
    width: 100%;
    background: #f5f6f7;
    padding: 10px 0;
    /deep/ .newRcTable .rcTable-content .ivu-table .ivu-table-header thead th {
        height: 42px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: none !important;
        border: 1px solid #e9e9e9 !important;
        background-color: #f0f2f3 !important;
    }
}
</style>
